const TRIP_CHAT_STAFF_ACCESS_EMAILS = new Set([
  // Keep in sync with the backend permission allowlist in svc-trip/src/api/v3/utils/tripChatStaffAccess.ts.
  // Backend remains the permission boundary; this only controls whether the staff form is shown.
  'andrew.he@luxuryescapes.com',
  'sarah.hierstaetter@luxuryescapes.com',
  'sam.hammond@luxuryescapes.com',
  'samuel.drown@luxuryescapes.com',
  'jake.gerstel@luxuryescapes.com',
  'joshua.paling@luxuryescapes.com',
  'luke.wang@luxuryescapes.com',
  'amanda.tansi@luxuryescapes.com',
])

export function canAccessStaffChat(email?: string): boolean {
  if (!email) {
    return false
  }

  return TRIP_CHAT_STAFF_ACCESS_EMAILS.has(email.trim().toLowerCase())
}
